e4.hash = {
    get: function ( strKey ) {
        var objReturnValue,
            arrHashes = [];
        if ( location.hash.indexOf( '#/' ) === 0 && location.hash.lastIndexOf( '/' ) === location.hash.length - 1 ) {
            arrHashes = location.hash.substring( 2, location.hash.length - 1 ).split( '&' );
        }
        if ( strKey === undefined ) {
            objReturnValue = {};
        }
        else {
            strKey = e4.hash.decode.key( e4.hash.encode.key( strKey ) );
        }
        for ( var i = 0; i < arrHashes.length; i++ ) {
            try {
                var arrHashKeyValue = arrHashes[ i ].split( '=' ),
                    hashKey = e4.hash.decode.key( arrHashKeyValue[ 0 ] ),
                    hashValue = e4.hash.decode.value( arrHashKeyValue.slice( 1 ).join( '=' ) );
                if ( strKey === hashKey ) {
                    objReturnValue = hashValue;
                    break;
                }
                else if ( strKey === undefined ) {
                    objReturnValue[ hashKey ] = hashValue;
                }
            }
            catch ( e ) {
            }
        }
        return objReturnValue;
    },
    set: function ( strKey, objValue ) {
        var arrHashes = e4.hash.buildNewHashArray( strKey, objValue ),
            strHash = e4.hash.buildNewHashString( arrHashes );
        //console.log( location.hash, e4.hash.getCurrentHashStringValue(), strHash, arrHashes );
        if ( e4.hash.getCurrentHashStringValue() !== strHash ) {
            location.hash = strHash;
            //console.log( 'hash changed - set' );
        }
    },
    replace: function ( strKey, objValue ) {
        var arrHashes = e4.hash.buildNewHashArray( strKey, objValue ),
            strHashNew = e4.hash.buildNewHashString( arrHashes ),
            strHashCurrent = e4.hash.getCurrentHashStringValue(),
            strUrl = location.href;
        //console.log( location.hash, e4.hash.getCurrentHashStringValue(), strHashNew, arrHashes );
        if ( strHashCurrent !== strHashNew ) {
            if ( location.href.indexOf( '#' ) === -1 ) {
                strUrl = strUrl + '#' + strHashNew;
            }
            else {
                strUrl = strUrl.replace( '#' + strHashCurrent, '#' + strHashNew );
            }
            window.history.replaceState( null, '', strUrl );
            jQuery( window ).triggerHandler( 'hashchange' );
            //console.log( 'hash changed - replace' );
        }
    },
    remove: function ( strKey ) {
        e4.hash.set( strKey, null );
    },
    buildNewHashArray: function ( strKey, objValue ) {
        var arrHashes = [],
            boolKeyExists = false;
        strKey = e4.hash.encode.key( strKey );
        jQuery.each( e4.hash.get(), function ( hashKey, hashValue ) {
            hashKey = e4.hash.encode.key( hashKey );
            hashValue = e4.hash.encode.value( hashValue );
            if ( hashKey === strKey ) {
                boolKeyExists = true;
                if ( objValue !== null ) {
                    hashValue = e4.hash.encode.value( objValue );
                    arrHashes.push( hashKey + '=' + hashValue );
                }
            }
            else {
                arrHashes.push( hashKey + '=' + hashValue );
            }
        } );
        if ( boolKeyExists === false && objValue !== null ) {
            arrHashes.push( strKey + '=' + e4.hash.encode.value( objValue ) );
        }
        return arrHashes;
    },
    buildNewHashString: function ( arrHashes ) {
        var strHash = '';
        if ( arrHashes.length !== 0 ) {
            strHash = '/' + arrHashes.join( '&' ) + '/';
        }
        return strHash;
    },
    getCurrentHashStringValue: function () {
        return location.hash.replace( /^#/, '' );
    },
    encode: {
        key: function ( strKey ) {
            return encodeURIComponent( String( strKey ).replace( /\s/g, '_' ) );
        },
        value: function ( objValue ) {
            if ( String( objValue ).charAt( 0 ) === '{' || typeof objValue === 'object' ) {
                try {
                    objValue = JSON.stringify( objValue );
                }
                catch ( e ) {
                }
            }
            return objValue === undefined ? '' : encodeURIComponent( objValue );
        }
    },
    decode: {
        key: function ( strKey ) {
            return decodeURIComponent( strKey );
        },
        value: function ( objValue ) {
            objValue = decodeURIComponent( objValue );
            if ( objValue.charAt( 0 ) === '{' ) {
                try {
                    objValue = JSON.parse( objValue );
                }
                catch ( e ) {
                }
            }
            return objValue;
        }
    }
};
